import React from 'react';
import { ExternalButtonLink } from '../external-link/external-link';

export const buttonStyles = {
  backgroundColor: 'red:60',
  fontFamily: 'interstate',
  color: 'white',
  _hover: { backgroundColor: 'rgba(215, 25, 32, 0.75)' },
  _active: { backgroundColor: 'rgba(215, 25, 32, 0.75)' },
  _focus: {
    boxShadow:
      'inset 0 0 0 0.0625rem rgba(215, 25, 32, 0.75), inset 0 0 0 0.125rem rgba(255, 255, 255, 1.0)',
    borderColor: 'rgba(215, 25, 32, 0.75)',
  },
};

export const PLExternalButtonLink = (props) => <ExternalButtonLink {...buttonStyles} {...props} />;
